import type { FilterAiOptions_Response } from '@zendesk/zqa-services/filters'
import { api } from '@/api'
import { session } from '@/composables/useSession'

export function getAiFilterOptions(prompt: string, signal?: AbortSignal): Promise<FilterAiOptions_Response> {
  return api
    .post('filter/ai-options', {
      headers: { 'X-Klaus-Workspace': session.workspace.id.toString() },
      json: { prompt },
      signal,
    })
    .json()
}
